<template>
<!-- プロジェクト削除モーダル -->
<transition name="modal">
  <!--
    閉じるのは背景を押したときだけ。中のどこを押しても閉じていたので、
    ［削除］を押した瞬間に小窓が消え、断られても元の画面に戻っただけに見えた。
    背景は wrapper が覆っているので、両方で受ける。
  -->
  <div class="modal-mask" @click.self="$emit('close')">
    <div class="modal-wrapper" @click.self="$emit('close')">
      <div class="modal-container">
        <div>
          <CRow>
            <CCol>
              <table class="table">
                <thead>
                  <a style="font-size: 20px"><strong>削除内容確認</strong></a>
                  <CCardText><strong>以下の内容を削除してよろしいですか？</strong></CCardText>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <a><strong>取引先企業名</strong></a><br>
                      {{ val.company_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>プロジェクト名</strong></a><br>
                      {{ val.name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>プロジェクト責任者</strong></a><br>
                      {{ val.private_staff_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>先方担当者</strong></a><br>
                      {{ val.staff_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>協力会社</strong></a><br>
                      {{ val.related }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>その他関連</strong></a><br>
                      {{ val.other_related }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>始業時刻</strong></a><br>
                      {{ val.start_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>終業時刻</strong></a><br>
                      {{ val.end_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>休憩開始時間</strong></a><br>
                      {{ val.break_start_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>休憩終了時間</strong></a><br>
                      {{ val.break_end_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>精算基準時間</strong></a><br>
                      {{ val.base_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>契約形態</strong></a><br>
                      {{ val.contract }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>その他契約事項</strong></a><br>
                      {{ val.other_contract }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>必要な資格・スキル</strong></a><br>
                      {{ val.language }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>使用機材・ツール</strong></a><br>
                      {{ val.other_tech }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CCol>
          </CRow>
          <ActionResultMessage :text="error" type="danger" />
          <CRow>
            <CCol sm="3">
              <button @click="$emit('close')" :disabled="cancelDisabled" class="btn btn-info">キャンセル</button>
            </CCol>
            <CCol sm="3" style="margin: 0 0 0 auto;">
              <save-button
                :label="'削除'"
                :loading="loading"
                class="btn btn-danger"
                @click="$emit('delete')"
              />
            </CCol>
          </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
import ActionResultMessage from '../components/ActionResultMessage.vue'
export default {
  components: { SaveButton, ActionResultMessage },
  name: 'ProjectDeleteModal',
  data() {
    return {}
  },
  props: {
    val: Object,
    loading: Boolean,
    /*
     * 送っているあいだキャンセルを押せなくする（2026-09-26 監査）。loading とは分けて持つ。
     * ProjectList も loading を渡しているが、あちらは結果を alert で出すので今までどおり押せる。
     */
    cancelDisabled: { type: Boolean, default: false },
    // 削除を断られた理由。小窓を閉じずにここへ出す。
    error: { type: String, default: '' }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(80, 80, 80, 0.5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-height: calc(100vh - 100px);
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: scroll;
}
</style>
